/**
 * AuthHeader - Header with logo and back button
 */
import React from 'react';
import logoImage from '../../../Assets/Images/logo.svg';

function AuthHeader({ title, subtitle, showBack, onBack }) {
  return (
    <div className="text-center mb-6">
      {showBack && (
        <button
          type="button"
          onClick={onBack}
          className="absolute left-4 top-4 p-2 rounded-full hover:bg-gray-100 transition-colors z-10"
          aria-label="Go back"
        >
          <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
      )}
      
      <div className="flex justify-center mb-4">
        <img src={logoImage} alt="CureBay" className="h-10 md:h-12" />
      </div>
      
      {title && (
        <h2 className="text-xl md:text-2xl font-semibold text-[#004171]">
          {title}
        </h2>
      )}
      
      {subtitle && (
        <p className="mt-2 text-sm text-gray-500">
          {subtitle}
        </p>
      )}
    </div>
  );
}

export default AuthHeader;
